<template>
  <div class="tir-pm-file-uploader" @click="inputFile">
    <input
      ref="$input"
      class="tir-pm-file-uploader__input"
      type="file"
      :accept="allowedExtensionsString"
      @change="handleFileChange"
      :multiple="isMultiple"
    />
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from "vue";
import { FileUploaderExtension } from "./types";
import { allExtensions, videoExtensions } from "./constants";
import { FileUploaderErrorTypeEnum } from "./enums";

const emit = defineEmits<{
  /**Событие загрузки файлов */
  (e: "uploadFiles", files: Array<File>): void;
  /**Событие ошибки загрузки файла */
  (e: "onError", errorType: FileUploaderErrorTypeEnum, file: File): void;
}>();

const props = defineProps({
  /**Допустимые расширения */
  allowedExtensions: {
    type: Array as PropType<Array<FileUploaderExtension>>,
    default: (): Array<FileUploaderExtension> => allExtensions,
  },
  /**Максимальный размер файла */
  maxSize: {
    type: Number,
    default: 26214400.01, // 25 МБ
  },
  /**Доступен выбор нескольких файлов */
  isMultiple: {
    type: Boolean,
    default: false,
  },
  /**Заблокировать */
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const $input = ref<HTMLInputElement>();

const inputFile = () => {
  if (props.isDisabled || !$input.value) return;
  $input.value.click();
};

const allowedExtensionsString = computed(() =>
  props.allowedExtensions.map((ext) => `.${ext}`).join(",")
);

const handleFileChange = (event: any) => {
  if (!event?.target?.files?.length) return;
  const eventFiles = event.target.files as Array<File>;
  const filesToUpload = new Array<File>();

  for (let index = 0; index < eventFiles.length; index++) {
    const file = eventFiles[index];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (props.allowedExtensions.some((ext) => ext === fileExtension)) {
        if (videoExtensions.some((ext) => ext === fileExtension) || file.size <= props.maxSize) {
          filesToUpload.push(file);
        } else {
          emit("onError", FileUploaderErrorTypeEnum.LimitSize, file);
        }
      } else {
        emit("onError", FileUploaderErrorTypeEnum.NoValidExtension, file);
      }
    }
  }

  if (filesToUpload.length) {
    emit("uploadFiles", filesToUpload);
  }
  event.target.value = "";
};
</script>

<style lang="scss" scoped>
@import "./tir-pm-file-uploader.scss";
</style>
